import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const dextTagsViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map